import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, Users } from 'lucide-react';
export function AudienceSection() {
  const isFor = ['Dueños de pequeños y medianos negocios.', 'Emprendedores sin experiencia técnica.', 'Empresarios que buscan liberar tiempo.', 'Consultores o freelancers con sobrecarga de tareas repetitivas.'];
  const isNotFor = ['Programadores o expertos en IA avanzada.', 'Empresas con grandes equipos tecnológicos.', 'Quienes buscan soluciones con código complejo.'];
  return <section className="py-24" data-id="element-1">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <div className="inline-flex justify-center items-center w-16 h-16 rounded-full bg-white/5 text-white mb-6" data-id="element-4">
            <Users className="w-8 h-8" data-id="element-5" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-6">
            ¿Para quién es este eBook?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-7">
          {/* Who it's for */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-[#141414] p-8 md:p-10 rounded-2xl border border-green-500/20 relative overflow-hidden" data-id="element-8">
            <div className="absolute top-0 right-0 w-32 h-32 bg-green-500/5 rounded-full blur-3xl" data-id="element-9" />
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-10">
              <span className="bg-green-500/20 text-green-500 p-2 rounded-lg" data-id="element-11">
                <Check className="w-6 h-6" data-id="element-12" />
              </span>
              Para quién SÍ es
            </h3>
            <ul className="space-y-6" data-id="element-13">
              {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-14">
                  <Check className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-15" />
                  <span className="text-lg text-gray-300" data-id="element-16">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who it's not for */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-[#141414] p-8 md:p-10 rounded-2xl border border-red-500/20 relative overflow-hidden" data-id="element-17">
            <div className="absolute top-0 right-0 w-32 h-32 bg-red-500/5 rounded-full blur-3xl" data-id="element-18" />
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-19">
              <span className="bg-red-500/20 text-red-500 p-2 rounded-lg" data-id="element-20">
                <X className="w-6 h-6" data-id="element-21" />
              </span>
              Para quién NO es
            </h3>
            <ul className="space-y-6" data-id="element-22">
              {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-23">
                  <X className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-24" />
                  <span className="text-lg text-gray-300" data-id="element-25">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}